import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { Alert, AlertTitle, Grid, Typography } from '@mui/material';

const ProjectEditorLightRecipeInfo = () => {
    const {
        pageState: { formData }
    } = usePageStore();
    const lightRecipeNum = (formData.spectrogramMap as unknown[]).length;
    return (
        <>
            {formData.recipeId ? (
                <Grid item xs={12}>
                    {lightRecipeNum ? (
                        <Typography mb={3} variant="h3">
                            {i18n('project_editor_recipe_info', lightRecipeNum)}
                        </Typography>
                    ) : (
                        <Alert severity="error">
                            <AlertTitle>Error</AlertTitle>
                            {i18n('project_editor_missing_light_recipes')}
                        </Alert>
                    )}
                </Grid>
            ) : null}
        </>
    );
};

export default ProjectEditorLightRecipeInfo;
